// Pháp nhân vận hành nền tảng Chốt Ca.
//
// Hai chế độ:
//   entityType: "individual"  — cá nhân vận hành (giai đoạn trước 10/07/2026)
//   entityType: "company"     — pháp nhân chính thức (hiện hành)
//
// Các doc (terms, privacy, eula, ve-chung-toi, payment-terms) đọc cờ entityType và
// tự ẩn/hiện block "MST" / "ĐKKD" cho phù hợp — không cần sửa từng doc.
//
// Nguồn sự thật: docs/07-legal.md mục 1.

export type LegalEntityType = "individual" | "company";

export const LEGAL_COMPANY = {
  entityType: "company" as LegalEntityType,

  // === Identity ===
  legalName: "CÔNG TY CỔ PHẦN CHỐT CA",
  legalNameEn: "CHOT CA JOINT STOCK COMPANY",

  // Tên thương hiệu hiển thị (không đổi)
  brandName: "Chốt Ca",

  // === Tax / registration ===
  taxId: "0319635156" as string | null,

  // Ngày bắt đầu hoạt động theo giấy chứng nhận đăng ký doanh nghiệp.
  incorporationDate: "2026-07-10" as string | null,

  // Chưa đối chiếu tên cơ quan cấp trên bản giấy — để null thì các doc tự ẩn
  // dòng này thay vì in thông tin chưa kiểm chứng.
  incorporationAuthority: null as string | null,

  // Cơ quan thuế quản lý trực tiếp.
  taxAuthority: "Thuế cơ sở 13, Thành phố Hồ Chí Minh" as string | null,

  // Ngành nghề kinh doanh chính theo đăng ký doanh nghiệp.
  businessLine:
    "Hoạt động của các đại lý tư vấn, giới thiệu và môi giới lao động, việc làm",

  // === Contact ===
  // Địa chỉ trụ sở chính theo giấy chứng nhận đăng ký doanh nghiệp.
  address: "89 Phan Đình Phùng, Phường Phú Nhuận, Thành phố Hồ Chí Minh",

  representative: "Võ Huỳnh — Người đại diện theo pháp luật",

  // === Emails (đã verify domain chotca.com) ===
  email: "support@chotca.com",
  dpoEmail: "privacy@chotca.com",
  abuseEmail: "abuse@chotca.com",
  billingEmail: "billing@chotca.com",
  legalEmail: "legal@chotca.com",

  hotline: null as string | null,
  zaloOA: "https://zalo.me/chotca",
  websiteUrl: "https://chotca.com",
  employerUrl: "https://tuyendung.chotca.com",

  // Hiệu lực bộ điều khoản hiện hành. Đổi giá trị này là đổi ngày hiệu lực
  // của cả 12 tài liệu.
  effectiveDate: "2026-09-01",
} as const;

export type LegalCompany = typeof LEGAL_COMPANY;
